import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };


export const getAll = async (params) => {
  try {
    const languageId = localStorage.getItem('i18nextLng');

    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/filters`,
      params,
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch (e) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const newSlot = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Slot`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar criar o slot";
    return responseFormat;
  }
};

export const getSlotById = async (id, slotCommitteeId) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/${id}`,
      {
        ...(slotCommitteeId && {
          params: {
            slotCommitteeId
          }
        })
      }
    );

    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getFilesSlotById = async (id) => {

  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/get-slot-files/${id}`
    );

    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};


export const updateSlot = async (id, request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/${id}`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar o Slot";
    return responseFormat;
  }
};

export const addFileSlot = async ({ formData, slotCommitteeId }) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/upload-slot-material/${slotCommitteeId}`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
        }
      },
    );

    responseFormat.data = response;
    responseFormat.error = null;

    return responseFormat;
  } catch (e) {
    responseFormat.error = e.response.data.errors[0] || "Não foi possível adicionar os arquivos";

    return responseFormat;
  }
};

export const deleteFileSlot = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios({
      method: "DELETE",
      url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/logically/${id}`,
    });
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar enviar o(s) arquivo(s)";
    return responseFormat;
  }
};

export const downloadFileSlot = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios({
      method: "GET",
      url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/download/${id}`,
      responseType: 'blob' 
    });
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao realizar download";
    return responseFormat;
  }
};


export const disabledSlot = async ({ id }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/${id}/${"I"}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    const { errors } = response.data;
    responseFormat.error = errors[0] || "async";
    return responseFormat;
  }
};

export const enableSlot = async ({ id }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/${id}/${"A"}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const deletedSlot = async ({ id }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    responseFormat.errorStatus = response.data;

    return responseFormat;
  }
};

export const updateSlotCommittee = async ({ slotCommitteeId, meetDate }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/slotCommittee/${slotCommitteeId}`,
      {
        meetDate
      }
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
}
